import React from 'react';
import PropTypes from 'prop-types';
import cn from './style.module.scss';

export function Wrapper(props) {
  const className = `${cn.wrapper} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

Wrapper.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * child components
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

Wrapper.defaultProps = {
  className: '',
  children: undefined,
};
